<template>
    <b-col>
        <b-row>
            <h3 class="ml-3">Deutsche Post Abschluss</h3>
        </b-row>
        <b-row class="my-2">
            <table class="table">
                <tbody>
                    <tr>
                        <th>Service</th>
                        <th>NonEu 5102</th>
                        <th>EU 5102</th>
                        <th>US 5104</th>
                    </tr>
                    <tr>
                        <td><a href="/deutschepost/current/rfid" target="_blank">RFID</a> / <a href="/deutschepost/current/untracked" target="_blank">Untracked</a></td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.untracked5102"></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.untracked5102eu"></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.untracked5104"></b-form-input>
                            </b-input-group>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="/deutschepost/current/tracked" target="_blank">Tracked (R)</a></td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.tracked5102"></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.tracked5102eu"></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.tracked5104"></b-form-input>
                            </b-input-group>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="/deutschepost/current/ebf" target="_blank">EBF</a></td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.ebf5102"></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.ebf5102eu"></b-form-input>
                            </b-input-group>
                        </td>
                        <td>
                            <b-input-group append="kg">
                                <b-form-input v-model="pickup.ebf5104"></b-form-input>
                            </b-input-group>
                        </td>
                    </tr>
                </tbody>
            </table>
        </b-row>
        <b-button block size="md" @click="submit()" variant="primary">Abschließen</b-button>
        <b-modal
            v-model="modalError.state"
            size="md"
            centered
            dismissible
        >
            {{modalError.message}}
        </b-modal>
        <b-row class="my-3 py-4 mx-0">
            <b-table
               id="table-pickups"
               v-if="pickups"
               :items="pickups"
               :fields="fields"
               :per-page="perPage"
               :current-page="currentPage"
               :tbody-tr-class="rowClass"
               small
            >
                <template v-slot:cell(weightSum)="row">{{parseFloat(row.item.weightSum).toFixed(2)}} kg</template>
                <template v-slot:cell(from)="row">{{formatDate(row.item.from)}}</template>
                <template v-slot:cell(to)="row">{{formatDate(row.item.to)}}</template>
                <template v-slot:cell(submissionTime)="row">{{(row.item.submissionTime) ? formatDate(row.item.submissionTime) : '-'}}</template>
                <template v-slot:cell(link)="row">
                    <b-button
                        @click="openInNewTab(`https://synch.mplusl.de/deutschepost/${row.item.id}`)"
                        size="sm"
                        block
                    ><!-- button -->
                        <span class="icon icon-arrow-right"/>
                    </b-button>
                </template>
            </b-table>
            <b-pagination
               v-if="pickups"
               v-model="currentPage"
               :total-rows="pickups.length"
               :per-page="perPage"
               aria-controls="table-pickups"
            ></b-pagination>
        </b-row>
    </b-col>
</template>
<script>
  export default
  {
        data() {
            return {
               pickups: [],
               perPage: 10,
               currentPage: 1,
               pickup: {
                   untracked5102: 0,
                   untracked5102eu: 0,
                   untracked5104: 0,
                   tracked5102: 0,
                   tracked5102eu: 0,
                   tracked5104: 0,
                   ebf5102: 0,
                   ebf5102eu: 0,
                   ebf5104: 0
               },
               modalError: {
                   state: false,
                   message: ""
               },
                fields: [
                    { key: "group", label: "Gruppe" },
                    { key: "contract", label: "Vertrag" },
                    { key: "from", label: "Von" },
                    { key: "to", label: "Bis" },
                    { key: "weightSum", label: "Gewicht" },
                    { key: "submissionTime", label: "Übermittlung" },
                    { key: "link", label: "" }
                ]
            }
        },
        methods: {
            openInNewTab(url) {
                var win = window.open(url, "_blank");
                win.focus();
            },
            rowClass(item, type) {
               if(item.submissionTime === null) {
                  return 'table-danger';
               }
            },
            submit() {
                axios.post('/deutschepost', this.pickup).then( response => {
                    this.pickup.untracked5102 = 0;
                    this.pickup.untracked5102eu = 0;
                    this.pickup.untracked5104 = 0;
                    this.pickup.tracked5102 = 0;
                    this.pickup.tracked5102eu = 0;
                    this.pickup.tracked5104 = 0;
                    this.pickup.ebf5102 = 0;
                    this.pickup.ebf5102eu = 0;
                    this.pickup.ebf5104 = 0;
                    console.log(response);
                }).catch( error => {
                    console.error(error);
                    this.modalError = {
                        state: true,
                        message: "Netzwerkfehler. Error: " + JSON.stringify(error)
                    }
                });
            },
            formatDate(s) {
               return moment(s).format('DD.MM.YYYY HH:mm');
            }
        },
        created() {
              console.log('=============');
              console.log(moment('2021-01-04 16:25:47').format('DD.MM.YYYY HH:mm'));
              console.log('=============');
            axios.get('/deutschepost/all').then( r => {
               this.pickups = r.data;
               this.pickups = r.data.sort( (a,b) => {
                  if(a.id == b.id) return 0;
                  if(a.id < b.id) return 1;
                  return -1;
               });
               // this.pickups = r.data.sort( (a,b) => { 
               //    if(a.created_at == null) return -1;
               //    if(b.created_at == null) return 1;
               //    return a.created_at.localeCompare(b.created_at) 
               // });
            }).catch( error => {
                console.log(error);
                alert("Netzwerkfehler");
            });

         
        }
    }
</script>
